<template>
	<div style="width: 100%;height: 100%;">
	</div>
</template>

<script>
	import 'leaflet/dist/leaflet.css'
	import L from 'leaflet'
	import geoJson from './130000.js'
	export default {
		name: 'lyMap',
		data() {
			return {
				map: null,
				layerGroup: null,
				layerGroupArr: [],
				layerControl: null,
				markerGroup: null,
				markIcon: L.icon({
					iconUrl: require('./icon.png'),
					iconSize: [24, 31], // size of the icon
					iconAnchor: [13, 31],
					popupAnchor: [-1, -20]
				})
			}
		},
		props: {
			defaultLayer: {
				type: Array,
				default: function() {
					return []
				},
			},
			geoJSONData: {
				//type: Object
			},
			layers: { // 图层列表
				type: Array,
				default: function() {
					return []
				}
			},
			points: { // 点位列表
				type: Array,
				default: function() {
					return []
				}
			},
			pointsGroup: {},
			bound: { // 显示范围
				type: Array,
				default: function() {
					return [
						[43.186231, 118.422797],
						[40.081638, 120.796048],
						[35.605063, 114.982503],
						[38.41883, 112.811622]
					]
				}
			},
			center: { // 中心点
				type: Array,
				default: function() {
					return [38.05, 114.48]
				}
			},
			zoom: { // 缩放系数
				type: Number,
				default: 7
			},
			minZoom: { // 最小缩放系数
				type: Number,
				default: 6
			},
			maxZoom: { // 最大缩放系数
				type: Number,
				default: 15
			},
			attributionControl: { // 右下角控制点
				type: Boolean,
				default: false
			},
			ismouseMark: { // 手动标记
				type: Boolean,
				default: true
			},
			showPopup: { // 显示提示
				type: Boolean,
				default: true
			},
			pointRemove: { // 标记点移除
				type: Boolean,
				default: false
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				let _this = this
				let dfLayer = []
				let baseLayers = {}
				let layerArr = []
				let controlLayer = {}
				
				if(this.defaultLayer.length === 0 && this.layers.length === 0){
					throw new Error('数据源不能为空！！！，请设置defaultLayer或者layers，详见API')
					return 
				}
				
				if(this.layers && this.layers.length) {
					for(let i = 0; i < this.layers.length; i++) {
						let currly = this.layers[i]
						if(currly.subdomains && currly.subdomains.length) {
							let cr = L.tileLayer(currly.url, {
								id: 'index' + i,
								subdomains: currly.subdomains
							})
							baseLayers['rdName' + i] = cr
							controlLayer[currly.name] = cr
						} else {
							let cu = L.tileLayer(currly.url, {
								id: 'index' + i,
								subdomains: ['0', '1', '2', '3', '4', '5', '6', '7']
							})
							baseLayers['rdName' + i] = cu
							controlLayer[currly.name] = cu
						}
					}

					for(let item in baseLayers) {
						layerArr.push(baseLayers[item])
					}
				}

				// 添加默认图层集 
				for(let i = 0; i < this.defaultLayer.length; i++) {
					let cls = this.defaultLayer[i]
					let clsLeays = null
					if(cls.subdomains && cls.subdomains) {
						clsLeays = L.tileLayer(cls.url, {
							id: 'clsIndex' + i,
							subdomains: cls.subdomains
						})
					}else{
						clsLeays = L.tileLayer(cls.url, {
							id: 'clsIndex' + i,
							subdomains: ['0']
						})
					}
					dfLayer.push(clsLeays)
				}
				
				// 如果 默认 图层为空，则显示控制图层的最后一个
				if(dfLayer.length === 0){
					if(this.layers.length){
						dfLayer.push(layerArr[layerArr.length-1])
					}
				}
				
				//var normal = L.layerGroup(layerArr)
				this.map = L.map(_this.$el, {
					attributionControl: _this.attributionControl, // 取消右下角logo
					zoom: _this.zoom, // 默认缩放级别
					minZoom: _this.minZoom, // 最新缩放
					maxZoom: _this.maxZoom, // 最大缩放
					layers: dfLayer, //[layerArr[layerArr.length - 1]],
					maxBounds: _this.bound
				}).setView(this.center)

				//标注点 控制
				let markerLayer = this.point_add()
				L.control.layers(controlLayer,markerLayer).addTo(this.map);

				this.add_geoJsonData()

				// 地图点击
				this.map.on('click', function(event) {
					_this.$emit('mapclick', event)
					if(_this.ismouseMark) {
						_this.markerGroup.clearLayers()
						let markArr = [event.latlng.lat, event.latlng.lng]
						let newMarkPoint = L.marker(markArr, {
							icon: _this.markIcon
						})
						newMarkPoint.bindPopup('鼠标点击添加de标记点')
						_this.point_delete(newMarkPoint, markArr)
						_this.markerGroup.addLayer(newMarkPoint)
					}
				})
			},
			add_geoJsonData() {
				if(this.geoJSONData) {
					L.geoJSON(this.geoJSONData, {
						style() {
							return {
								color: 'gray',
								fillColor: '#fff',
								weight: 2
							}
						}
					}).addTo(this.map);
				}
			},
			map_zoomout() { // 缩小
				if(this.map) this.map.setZoom(this.map.getZoom() - 1)
			},
			map_zoomin() { // 缩小
				if(this.map) this.map.setZoom(this.map.getZoom() + 1)
			},
			map_zoom(zoomType) { // 放大/缩小
				zoomType ? this.map_zoomin() : this.map_zoomout()
			},
			map_moveto(center) { // 移动
				if(this.map) this.map.flyTo(center);
			},

			layers_add(layersUrl, mapName) { // 添加图层

			},

			layers_delete(rm_layer) { // 删除图层

			},

			point_list() { //点位列表

			},

			point_add() { // 点位添加
				this.markerGroup = new L.layerGroup()
				for(let i = 0; i < this.points.length; i++) {
					let li = this.points[i]
					let marks = null
					marks = L.marker([li[0], li[1]], {
						icon: this.markIcon
					})
					if(this.showPopup && this.pointsGroup.length) {
						marks.bindPopup(this.pointsGroup[i].htmls)
					}
					marks.addTo(this.markerGroup)
					this.point_delete(marks, li)
				}
				let markerLayer = {
					'标记点': this.markerGroup
				}
				this.map.addLayer(this.markerGroup)
				return markerLayer
			},

			point_delete(marker, currData) { // 点位删除
				var _this = this;
				marker.on('click', function() {
					if(_this.pointRemove) {
						_this.$emit('removeMarkPoint', currData)
						marker.remove()
					}
				})
			},
			leayers_opt() {}
		}
	}
</script>

<style></style>


// WEBPACK FOOTER //
// map.vue?63db17da